import * as React from 'react'
import { Button, Classes, Intent, Text } from '@blueprintjs/core'
import CX from 'classnames'
import { ProductOverride } from '../../types/api/product'
import { BulkRemoveProductAttributeOverrideDialog } from '../../routes/listing_manager/shopify/BulkRemoveProductAttributeOverrideDialog'
import { showSuccess } from '../../Toast'
import './priceOverridesInfoStyle.scss'
import { formatMoneyWithCurrency } from '../../utils'

interface Props {
  productId: number
  overrideProperties: ProductOverride // Product.overriddenValues
  onSuccess?: () => void
}

export const ProductOverridesInfo: React.FC<Props> = props => {
  const [removeDialogOpen, setRemoveDialogOpen] = React.useState(false)

  return (
    <>
      {!!props.overrideProperties && (
        <div className="price-override-info-container">
          <p>Price Override Running</p>
          <Text className={CX(Classes.TEXT_SMALL, Classes.TEXT_MUTED, 'price-override-info-text-section')}>
            Editing price and compare at price is not available.
          </Text>
          <div className="price-override-info-text-section">
            <Text className={CX(Classes.TEXT_SMALL, Classes.TEXT_MUTED)}>
              Price override:{' '}
              {props.overrideProperties?.discountType === 'percentage'
                ? `-${props.overrideProperties?.discountValue}%`
                : `-${formatMoneyWithCurrency(props.overrideProperties?.discountValue, 'USD')}`}
            </Text>
            {props.overrideProperties?.compareAtPriceOverrideType && (
              <Text className={CX(Classes.TEXT_SMALL, Classes.TEXT_MUTED)}>
                {props.overrideProperties?.compareAtPriceOverrideType === 'override_with_value'
                  ? `Compare at override: ${formatMoneyWithCurrency(
                      props.overrideProperties?.compareAtPriceOverrideValue,
                      'USD'
                    )}`
                  : 'Compare at override: price before discount'}
              </Text>
            )}
          </div>
          <Button intent={Intent.DANGER} onClick={() => setRemoveDialogOpen(true)}>
            End price override
          </Button>
        </div>
      )}
      <BulkRemoveProductAttributeOverrideDialog
        onClose={shouldShowSuccess => {
          if (shouldShowSuccess) {
            showSuccess('Product override removed successfully')
            props.onSuccess()
          }
          setRemoveDialogOpen(false)
        }}
        isOpen={removeDialogOpen}
        productIds={[props.productId]}
      />
    </>
  )
}
